import {createAction, props} from '@ngrx/store';
import {PumpFilter} from './pump.state';
import {DeviceListResponseDto, DeviceResponseDto, DeviceUpdateRequest} from '../../devices/models/device-response.interface';

const ACTION_PREFIX = '[Pump]';

type UpdatePumpActionPayload = Omit<DeviceUpdateRequest, 'type'>;

export const PumpActions = {
  public: {
    updatePumpFilter: createAction(
      `${ACTION_PREFIX} updatePumpFilter`,
      props<{
        filter: PumpFilter
      }>(),
    ),

    triggerPumpAction: createAction(
      `${ACTION_PREFIX} triggerPumpAction`,
      props<{
        id: string,
        value: boolean,
      }>(),
    ),

    updatePump: createAction(
      `${ACTION_PREFIX} updatePump`,
      props<UpdatePumpActionPayload>(),
    ),

    deletePumpById: createAction(
      `${ACTION_PREFIX} deletePumpById`,
      props<{
        id: string
      }>(),
    ),

    loadConnectedValves: createAction(
      `${ACTION_PREFIX} loadConnectedValves`,
      props<{
        pumpId: string
      }>(),
    ),

    replaceConnectedValves: createAction(
      `${ACTION_PREFIX} replaceConnectedValves`,
      props<{
        pumpId: string,
        connectedValveIds: string[],
      }>(),
    ),
  },

  private: {
    loadPumpsWithFilters: createAction(
      `${ACTION_PREFIX} loadPumpsWithFilters`,
    ),

    loadPumpsSuccess: createAction(
      `${ACTION_PREFIX} loadPumpsSuccess`,
      props<{ devicesResponseDto: DeviceListResponseDto }>(),
    ),

    loadPumpsFailure: createAction(
      `${ACTION_PREFIX} loadPumpsFailure`,
      props<{ error: any }>(),
    ),

    triggerPumpActionSuccess: createAction(
      `${ACTION_PREFIX} triggerPumpActionSuccess`,
      props<{
        responseDto: DeviceResponseDto,
      }>(),
    ),

    triggerPumpActionFailure: createAction(
      `${ACTION_PREFIX} triggerPumpActionFailure`,
      props<{
        id: string,
        attemptedValue: boolean,
        error: any,
      }>(),
    ),

    updatePumpSuccess: createAction(
      `${ACTION_PREFIX} updatePumpSuccess`,
      props<{
        responseDto: DeviceResponseDto,
      }>(),
    ),

    updatePumpFailure: createAction(
      `${ACTION_PREFIX} updatePumpFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    loadConnectedValvesSuccess: createAction(
      `${ACTION_PREFIX} loadConnectedValvesSuccess`,
      props<{
        pumpId: string,
        devicesResponseDto: DeviceListResponseDto,
      }>(),
    ),

    loadConnectedValvesFailure: createAction(
      `${ACTION_PREFIX} loadConnectedValvesFailure`,
      props<{
        pumpId: string,
        error: any,
      }>(),
    ),

    replaceConnectedValvesSuccess: createAction(
      `${ACTION_PREFIX} replaceConnectedValvesSuccess`,
      props<{
        pumpId: string,
        devicesResponseDto: DeviceListResponseDto,
      }>(),
    ),

    replaceConnectedValvesFailure: createAction(
      `${ACTION_PREFIX} replaceConnectedValvesFailure`,
      props<{
        pumpId: string,
        error: any,
      }>(),
    ),
  }
}
